// extracted by mini-css-extract-plugin
export default {"container":"ConfirmLayoutDeleteModal_container__FB6gC","text":"ConfirmLayoutDeleteModal_text__BpR0W","input":"ConfirmLayoutDeleteModal_input__Uf840"};